<template>
  <v-autocomplete
    clearable
    dense
    item-text="name"
    item-value="id"
    outlined
    hide-details
    :disabled="disabled"
    :items="availableTeams"
    :label="this.$t('common.team_one')"
    :loading="isLoadingTeams"
    :value="selectedTeamId"
    @change="$emit('change', $event)"
  >
    <template v-slot:no-data>
      <p class="body-2 px-4 py-2 ma-0">
        {{ noDataLabel }}
      </p>
    </template>
  </v-autocomplete>
</template>

<script>
import api from '@/api'
import mixin from '@/mixins/mixin.vue'

export default {
  name: 'TeamSelectorAddBulk',

  mixins: [mixin],

  props: {
    disabled: Boolean,
    selectedTeamId: String,
    siteId: {
      type: String,
      required: true,
    },
    organizationId: {
      type: String,
      required: true,
    },
  },

  mounted() {
    if (this.siteId) {
      this.fetchAvailableTeams()
    }
  },

  data() {
    return {
      isLoadingTeams: false,
      availableTeams: [],
    }
  },

  computed: {
    noDataLabel() {
      return this.availableTeams.length > 0
        ? this.$t('common.no_data_available')
        : this.$t('common.no_teams_created')
    },
  },

  methods: {
    async fetchAvailableTeams() {
      try {
        this.isLoadingTeams = true
        const response = await api.teams.getTeamsCatalog(this.organizationId, {
          filters: {
            sites: [this.siteId, 'null'],
          },
        })

        this.availableTeams = response.data
      } catch (err) {
        this.handleRequestError(err)
      } finally {
        this.isLoadingTeams = false
      }
    },
  },
  watch: {
    siteId() {
      if (this.siteId) {
        this.fetchAvailableTeams()
      }
    },
  },
}
</script>
